import { computed } from "@vue/composition-api";
import store from "@/store";

/**
 * Nieuwe inkomende conversaties in 'Nieuw': soundNotifyConversationUnassigned
 * Elke nieuwe reactie van conversaties in 'Nieuw': soundNotifyIncomingMessageNew
 * Wanneer een conversatie aan mij wordt toegewezen: soundNotifyConversationAssigned
 * Nieuwe reactie op een aan mij toegewezen conversatie: soundNotifyIncomingMessage
 */
export default function useSoundNotifications() {
    const soundNotifyConversationUnassigned = computed({
        get: () => store.state.soundNotifications.soundNotifyConversationUnassigned,
        set: (val) => {
            store.commit("soundNotifications/UPDATE_SOUND_NOTIFY_CONVERSATION_UNASSIGNED", val);
        },
    });
    const soundNotifyIncomingMessageNew = computed({
        get: () => store.state.soundNotifications.soundNotifyIncomingMessageNew,
        set: (val) => {
            store.commit("soundNotifications/UPDATE_SOUND_NOTIFY_INCOMING_MESSAGE_NEW", val);
        },
    });
    const soundNotifyConversationAssigned = computed({
        get: () => store.state.soundNotifications.soundNotifyConversationAssigned,
        set: (val) => {
            store.commit("soundNotifications/UPDATE_SOUND_NOTIFY_CONVERSATION_ASSIGNED", val);
        },
    });
    const soundNotifyIncomingMessage = computed({
        get: () => store.state.soundNotifications.soundNotifyIncomingMessage,
        set: (val) => {
            store.commit("soundNotifications/UPDATE_SOUND_NOTIFY_INCOMING_MESSAGE", val);
        },
    });
    const soundNotifyTeamchatStarted = computed({
        get: () => store.state.soundNotifications.soundNotifyTeamchatStarted,
        set: (val) => {
            store.commit("soundNotifications/UPDATE_SOUND_NOTIFY_TEAMCHAT_ASSIGNED", val);
        },
    });
    const soundNotifyTeamchatMessage = computed({
        get: () => store.state.soundNotifications.soundNotifyTeamchatMessage,
        set: (val) => {
            store.commit("soundNotifications/UPDATE_SOUND_NOTIFY_TEAMCHAT_MESSAGE", val);
        },
    });

    const audioInstance = (url) => new Audio(url);

    return {
        soundNotifyConversationUnassigned,
        soundNotifyConversationAssigned,
        soundNotifyIncomingMessageNew,
        soundNotifyIncomingMessage,
        soundNotifyTeamchatStarted,
        soundNotifyTeamchatMessage,

        audioInstance, // VueUse sound instance.
    };
}
